var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kangfu_video",on:{"click":_vm.onClick}},[_c('div',{staticClass:"kangfu_video_file"},[_c('img',{attrs:{"src":_vm.item.coverUrl}})]),_c('div',{staticClass:"kangfu_video_title van-multi-ellipsis--l2"},[_vm._v(_vm._s(_vm.item.videoName))])])
}
var staticRenderFns = []

export { render, staticRenderFns }